

/**
 * @file mutations
 */

// 1.获取任务列表
export function CHANGE_NAVBAR_STATUS(state, val) {
    state.isSideBarShow = val;
}
export function CHANGE_LOADING_STATUS(state, val) {
    state.loading = val;
}
export function SET_USER_INFO(state, val) {
    state.userInfo = {
        ...state.userInfo,
        ...val
    }
}

